// extracted by mini-css-extract-plugin
export default {"header-container":"uriY","headerContainer":"uriY","minimize-button":"ss1Q","minimizeButton":"ss1Q","is-minimized":"YiAZ","isMinimized":"YiAZ","logo":"QQkq","vl":"CFMJ"};